var _rect, _rect2, _rect3, _path, _rect4, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIc33Pilates(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7.50781,
    y: 30.6982,
    width: 32.3077,
    height: 3.46154,
    rx: 1.73077,
    transform: "rotate(-45 7.50781 30.6982)",
    fill: "#84919D"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8.32422,
    y: 21.7236,
    width: 4.61538,
    height: 15,
    rx: 1.15385,
    transform: "rotate(-45 8.32422 21.7236)",
    fill: "#0C65E5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.95652 23.3559C9.50591 22.9053 8.77534 22.9053 8.32473 23.3559L6.69295 24.9877C6.24234 25.4383 6.24234 26.1689 6.69295 26.6195L14.036 33.9625C14.4866 34.4131 15.2172 34.4131 15.6678 33.9625L17.2995 32.3307C17.7502 31.8801 17.7502 31.1496 17.2995 30.699L9.95652 23.3559Z",
    fill: "#237AF2"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 4.61538,
    height: 15,
    rx: 1.15385,
    transform: "matrix(-0.707107 0.707107 0.707107 0.707107 21.3789 8.66992)",
    fill: "#0C65E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0112 10.3012C22.5606 9.85064 22.5606 9.12006 23.0112 8.66946L24.643 7.03767C25.0936 6.58707 25.8242 6.58707 26.2748 7.03767L33.6178 14.3807C34.0684 14.8313 34.0684 15.5619 33.6178 16.0125L31.986 17.6443C31.5354 18.0949 30.8048 18.0949 30.3542 17.6443L23.0112 10.3012Z",
    fill: "#237AF2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIc33Pilates);
export default __webpack_public_path__ + "static/media/Ic3.3Pilates.c53c57121cf9954f8e77b63f797be65f.svg";
export { ForwardRef as ReactComponent };